/** Стратегии биддера для Ozon / Avito (визуал как у WB). */

export const ozonStrategyOptions = [
  { value: 'target_drr', label: 'По ДРР', targetKey: 'target_drr', targetLabel: 'Целевой ДРР, %', placeholder: '12' },
  { value: 'target_cpc', label: 'По стоимости клика', targetKey: 'target_cpc', targetLabel: 'CPC, ₽', placeholder: '15' },
  { value: 'conversion_cost', label: 'По стоимости заказа (CPO)', targetKey: 'target_conversion_cost', targetLabel: 'CPO, ₽', placeholder: '350' },
  { value: 'max_spend', label: 'Ограничение расхода/день', targetKey: 'daily_budget', targetLabel: 'Бюджет, ₽', placeholder: '5000' },
];

export const avitoListingStrategyOptions = [
  { value: 'position', label: 'По позиции в выдаче', targetKey: 'target_position', targetLabel: 'Целевая позиция', placeholder: '5' },
  { value: 'target_cpc', label: 'По стоимости клика', targetKey: 'max_bid_kopecks', targetLabel: 'Макс. ставка, ₽', kopecks: true, placeholder: '50' },
  { value: 'conversion_cost', label: 'По стоимости контакта', targetKey: 'target_contact_cost', targetLabel: 'CPC контакт, ₽', placeholder: '120' },
  { value: 'daily_limit', label: 'Дневной лимит', targetKey: 'daily_limit_kopecks', targetLabel: 'Лимит/день, ₽', kopecks: true, placeholder: '500' },
];

export const avitoAdsStrategyOptions = [
  { value: 'target_cpa', label: 'По CPA (Метрика)', targetKey: 'target_cpa', targetLabel: 'CPA, ₽', placeholder: '450' },
  { value: 'target_roi', label: 'По ROI', targetKey: 'target_roi', targetLabel: 'ROI, %', placeholder: '150' },
  { value: 'target_cpc', label: 'По стоимости клика', targetKey: 'target_cpc', targetLabel: 'CPC, ₽', placeholder: '25' },
  { value: 'max_spend', label: 'Дневной бюджет', targetKey: 'daily_budget', targetLabel: 'Бюджет, ₽', placeholder: '8000' },
];

export function getStrategyOptions(marketplace) {
  if (marketplace === 'ozon') return ozonStrategyOptions;
  if (marketplace === 'avito_listing') return avitoListingStrategyOptions;
  if (marketplace === 'avito_ads') return avitoAdsStrategyOptions;
  return [];
}

export function formatMarketplaceStrategy(row, marketplace) {
  if (!row?.bidder_enabled) return 'Биддер выключен';
  const opts = getStrategyOptions(marketplace);
  const opt = opts.find((o) => o.value === row.strategy_type) || opts[0];
  if (!opt) return 'Стратегия не настроена';
  let val = row[opt.targetKey];
  if (opt.kopecks && val != null) val = Number(val) / 100;
  if (val != null && val !== '') {
    const suffix = opt.targetKey.includes('drr') || opt.targetKey === 'target_roi' ? '%' : ' ₽';
    return `${opt.label}: ${Number(val).toLocaleString('ru-RU')}${suffix}`;
  }
  return opt.label;
}

export function strategyFormFromRow(row, marketplace) {
  const opts = getStrategyOptions(marketplace);
  const opt = opts.find((o) => o.value === (row?.strategy_type || opts[0]?.value)) || opts[0];
  let target = row?.[opt?.targetKey];
  if (opt?.kopecks && target != null) target = Number(target) / 100;
  return {
    bidder_enabled: Boolean(row?.bidder_enabled),
    automation_enabled: Boolean(row?.automation_enabled),
    strategy_type: row?.strategy_type || opt?.value || 'target_drr',
    target_value: target != null && target !== '' ? String(target) : '',
    min_bid: row?.min_bid != null ? String(row.min_bid) : '5',
    max_bid: row?.max_bid != null ? String(row.max_bid) : '500',
    daily_budget: row?.daily_budget ?? row?.settings_daily_budget ?? 0,
    stock_threshold: row?.stock_threshold != null ? String(row.stock_threshold) : '',
  };
}

export function strategyFormToPayload(values, marketplace, optOverride) {
  const opts = getStrategyOptions(marketplace);
  const opt = optOverride || opts.find((o) => o.value === values.strategy_type) || opts[0];
  const payload = {
    bidder_enabled: values.bidder_enabled ? 1 : 0,
    automation_enabled: values.automation_enabled ? 1 : 0,
    strategy_type: values.strategy_type,
    min_bid: Number(values.min_bid) || 5,
    max_bid: Number(values.max_bid) || 500,
  };
  if (values.daily_budget != null) payload.daily_budget = Number(values.daily_budget) || 0;
  if (opt?.targetKey && values.target_value !== '') {
    let v = Number(values.target_value);
    if (opt.kopecks) v = Math.round(v * 100);
    payload[opt.targetKey] = v;
  }
  if (marketplace === 'ozon') {
    if (values.strategy_type === 'target_drr') payload.target_drr = Number(values.target_value) || 12;
    if (values.strategy_type === 'target_cpc') payload.target_cpc = Number(values.target_value) || null;
    if (values.strategy_type === 'conversion_cost') payload.target_conversion_cost = Number(values.target_value) || null;
  }
  if (marketplace === 'avito_ads') {
    if (values.strategy_type === 'target_cpa') payload.target_cpa = Number(values.target_value) || 500;
    if (values.strategy_type === 'target_roi') payload.target_roi = Number(values.target_value) || null;
    if (values.strategy_type === 'target_cpc') payload.target_cpc = Number(values.target_value) || null;
  }
  return payload;
}
